export class ACLAssigneeModel {
    id;
    email;
    firstName;
    lastName;
    username;
    company;
}
export class ACLAssignee extends ACLAssigneeModel {
    get name() {
        let name = '';
        if (this.firstName && this.lastName) {
            name = `${this.firstName} ${this.lastName}`;
        }
        else if (this.company) {
            name = `${this.company}`;
        }
        return name ? `${name} / ${this.email}` : this.email;
    }
    constructor(model) {
        super();
        Object.keys(model).forEach((key) => {
            this[key] = model[key];
        });
    }
}
